export const strategyCanvasUrls = {
  GET_DASHBOARD: "/coach/strategy-canvas/dashboard",
  GET_CANVAS_STATUS: "/coach/strategy-canvas/{uniqueId}",
  GET_SUMMARY: "/coach/strategy-canvas/{uniqueId}/summary",
  GET_BUSINESS_CONTEXT: "/coach/strategy-canvas/{uniqueId}/business-context",
  GET_DOCUMENTS: "/coach/strategy-canvas/{uniqueId}/documents",
  GET_HOW_CEO_BUILT: "/coach/strategy-canvas/{uniqueId}/ceo-journey",
  GET_XRAY: "/coach/strategy-canvas/{uniqueId}/xray",
  GET_SUMMARY_DOWNLOAD: "/coach/strategy-canvas/{uniqueId}/summary/download",
  GET_CEO_JOURNEY_DOWNLOAD: "/coach/strategy-canvas/{uniqueId}/ceo-journey/download",
  GET_CANVAS_DOWNLOAD: "/coach/strategy-canvas/{uniqueId}/canvas/download",
  POST_REVIEW_ENTER: "/coach/strategy-canvas/{uniqueId}/review/enter",
  GET_SHARED_FILE_DOWNLOAD: "/shared/download/coach/{fileId}",
};
